import clsx from "clsx";
import { type FunctionComponent } from "react";
import type { PostListItem } from "~/database/post.model";
import FlowRow from "../Common/FlowRow";
import TopHead from "../Top/TopHead";
import { Link } from "@remix-run/react";
interface TopBreakingsProps {
  data: PostListItem[];
}

const TopBreakings: FunctionComponent<
  TopBreakingsProps
> = ({ data }) => {
  console.log("data:", data);
  return (
    <div
      className={clsx("pt-100", "max-md:pt-60")}
    >
      <TopHead type="text">BREAKING</TopHead>
      <div
        className={clsx(
          "flex",
          "flex-col",
          "gap-24",
          "mt-45",
          "max-md:mt-30",
          "max-md:gap-25",
        )}
      >
        {data.map((el, i) => {
          return (
            <Link
              className={clsx(
                "border-t",
                "border-black",
                "border-b",
                "py-10",
              )}
              key={i}
              to={`/${el?.user_display_id}/posts/${el?.display_id}/`}
            >
              <FlowRow isRev={i % 2 === 1}>
                <div className={clsx("pr-20")}>
                  <h3
                    className={clsx(
                      "text-20",
                      "font-bold",
                    )}
                  >
                    {el?.title}
                  </h3>
                </div>
              </FlowRow>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default TopBreakings;
